import { useContext } from 'react';
import { Navigate, useLocation } from '@tanstack/react-router';
import { AuthContext } from '@/auth/context.js';
import { LoadingPage } from '@/components/loading-page.js';
import { isCoachOffboarded } from '@/lib/coach-utils.js';

export function RouteGuard({ children }: { children: React.ReactNode }) {
  const { loggedInUser, loading } = useContext(AuthContext);
  const location = useLocation();
  const loginRoutePath = '/login';

  if (location.pathname === loginRoutePath) {
    return <>{children}</>;
  }

  if (loading) {
    return <LoadingPage />;
  }

  if (isCoachOffboarded(loggedInUser) && location.pathname !== loginRoutePath) {
    return <Navigate to={loginRoutePath} replace />;
  }

  return <>{children}</>;
}
